import { FilterGroup, Zone } from 'types';

import { mapZonesIntoOptions } from 'helpers/mapIntoOptions';

const getFilters = (statues: string[], zones: Zone[]): FilterGroup[] => {
  const zoneOptions = mapZonesIntoOptions(zones).map((item) => ({
    value: item.label,
    label: item.label,
  }));

  const statusOptions = statues.map((item: string) => ({
    name: item,
    value: item,
    label: item.replace('_', ' '),
  }));

  return [
    {
      id: 1,
      filters: [
        {
          name: 'user',
          label: 'Customer code',
          flex: 1,
          placeholder: 'Customer code...',
        },
        {
          name: 'zone',
          label: 'Zone',
          type: 'select',
          options: zoneOptions,
        },
        {
          name: 'status',
          label: 'Status',
          type: 'select',
          options: statusOptions,
        },
      ],
    },
    {
      id: 2,
      filters: [
        {
          name: 'datein',
          label: 'Date start',
          type: 'date',
        },
        {
          name: 'dateout',
          label: 'Date end',
          type: 'date',
        },
      ],
    },
  ];
};

export { getFilters };
